import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
const _excluded = ["phone"];
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BackdropLoader, toast, Icon, ExpandedTooltip } from '@livable/saas-react-components';
import { Button, Checkbox, Chip, FormControlLabel, FormGroup, Grid, IconButton, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
// import { PhoneInput } from '@livable/saas-react-components';
import { useStore } from 'src/stores';
import InputMask from 'react-input-mask';
import { PersonalDetailsSchema } from 'src/utils/formValidation/PersonalDetails';
import { beforeSubmitDataValidation } from 'src/core/services/beforeSubmitDataValidation';
import { translate } from 'src/utils/translator';
import useStyles from '../styles';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
import RequestToUseCustomAddress from 'src/components/shared/RequestToUseCustomAddress';
import { RESIDENCY_ADDRESS_STATUS } from 'src/constants/residency';
export const ResidentDetailsTab = observer(_ref => {
  let accountId = _ref.accountId,
    residencyId = _ref.residencyId,
    activeResidency = _ref.activeResidency,
    parentToggleRefreshCallback = _ref.parentToggleRefreshCallback;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState({
      email: '',
      phone: '',
      lastName: '',
      firstName: ''
    }),
    _useState2 = _slicedToArray(_useState, 2),
    user = _useState2[0],
    setUser = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    linkedResidents = _useState4[0],
    setLinkedResidents = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    unlinkChecked = _useState6[0],
    setUnlinkChecked = _useState6[1];
  const _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    currentUser = _useState8[0],
    setCurrentUser = _useState8[1];
  const _useState9 = useState(true),
    _useState0 = _slicedToArray(_useState9, 2),
    isSumbitDisabled = _useState0[0],
    setIsSumbitDisabled = _useState0[1];
  const _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isLoading = _useState10[0],
    setIsLoading = _useState10[1];
  const _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    residencyAddresses = _useState12[0],
    setResidencyAddresses = _useState12[1];
  const formik = useFormik({
    initialValues: user,
    validationSchema: PersonalDetailsSchema,
    enableReinitialize: true,
    onSubmit: async values => {
      const phoneCode = store.account.featureFlagsStore.isUkrainianMobileCode ? '+38' : '+1';
      const phone = values.phone,
        rest = _objectWithoutProperties(values, _excluded);
      const data = beforeSubmitDataValidation(_objectSpread({
        phone: phone.length > 0 ? "".concat(phoneCode).concat(phone) : ''
      }, rest));
      if (data.firstName !== currentUser.firstName || data.lastName !== currentUser.lastName) {
        const updateFirstLastNamesAsync = await store.account.updateProfileByAccountIdAsync.run({
          accountId: accountId,
          firstname: data.firstName,
          lastname: data.lastName
        });
        if (!updateFirstLastNamesAsync || !updateFirstLastNamesAsync.isSuccessful) return;
      }
      if (data.email !== currentUser.email) {
        const unlinkCheckedValue = unlinkChecked ? {
          unlinkAccount: true
        } : {};
        const updateEmailAsync = await store.account.updateEmailByAccountIdAsync.run(_objectSpread({
          accountId: accountId,
          email: data.email
        }, unlinkCheckedValue));
        if (!updateEmailAsync || !updateEmailAsync.isSuccessful) return;
      }
      if (data.phone.length > 0 && data.phone !== currentUser.phone || data.phone.length === 0 && currentUser.phone && currentUser.phone.length > 0) {
        const updatePhoneAsync = await store.account.updatePhoneByAccountIdAsync.run({
          accountId: accountId,
          phone: data.phone
        });
        if (!updatePhoneAsync || !updatePhoneAsync.isSuccessful) return;
      }
      setCurrentUser(data);
      setIsSumbitDisabled(true);

      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      parentToggleRefreshCallback && parentToggleRefreshCallback();
      toast('success', {
        body: ['Successfully submitted']
      });
    }
  });
  const validIsSumbitDisabled = (id, value) => {
    const phoneCode = store.account.featureFlagsStore.isUkrainianMobileCode ? '+38' : '+1';
    const _formik$values = formik.values,
      currentField = _formik$values[id],
      rest = _objectWithoutProperties(_formik$values, [id].map(_toPropertyKey));
    const tempValues = _objectSpread({
      [id]: value
    }, rest);
    if (tempValues.phone.length > 0) {
      tempValues.phone = "".concat(phoneCode).concat(tempValues.phone);
    }
    const currentValues = beforeSubmitDataValidation(tempValues);
    for (const prop in currentValues) {
      if (currentValues[prop] !== currentUser[prop]) {
        setIsSumbitDisabled(false);
        break;
      } else {
        setIsSumbitDisabled(true);
      }
    }
  };
  const fetchAddresses = async () => {
    setIsLoading(true);
    const data = [];
    const residencyAddressesResp = await store.residencies.getResidencyAddressesAsync.run({
      residencyId: residencyId
    });
    const residencyAddressesIds = residencyAddressesResp.response.map(i => i.addressId);
    const addressResp = await store.address.batchGetAddressesAsync.run({
      addressIds: residencyAddressesIds
    });
    residencyAddressesResp.response.map(i => {
      const cData = i;
      cData.details = addressResp.response.find(e => e.addressId === i.addressId);
      data.push(cData);
    });
    setResidencyAddresses(data);
    setIsLoading(false);
  };
  useEffect(() => {
    const getUserProfile = async data => {
      const resp = await store.account.getUsersProfilesAsync.run(data);
      return resp;
    };
    getUserProfile({
      accountIds: [accountId]
    }).then(async resp => {
      var _singleElementOfArray;
      if (!resp) return;
      if (((_singleElementOfArray = singleElementOfArray(resp === null || resp === void 0 ? void 0 : resp.response)) === null || _singleElementOfArray === void 0 || (_singleElementOfArray = _singleElementOfArray.subAccounts) === null || _singleElementOfArray === void 0 ? void 0 : _singleElementOfArray.length) > 0) {
        var _singleElementOfArray2;
        const filteredLinkedResidents = (_singleElementOfArray2 = singleElementOfArray(resp === null || resp === void 0 ? void 0 : resp.response)) === null || _singleElementOfArray2 === void 0 || (_singleElementOfArray2 = _singleElementOfArray2.subAccounts) === null || _singleElementOfArray2 === void 0 ? void 0 : _singleElementOfArray2.filter(i => {
          var _singleElementOfArray3;
          return i.accountId !== ((_singleElementOfArray3 = singleElementOfArray(resp === null || resp === void 0 ? void 0 : resp.response)) === null || _singleElementOfArray3 === void 0 ? void 0 : _singleElementOfArray3.id);
        });
        if (filteredLinkedResidents.length > 0) setLinkedResidents(filteredLinkedResidents);
      }
      setCurrentUser({
        email: singleElementOfArray(resp.response).email ? singleElementOfArray(resp.response).email : singleElementOfArray(resp.response).newEmail ? singleElementOfArray(resp.response).newEmail : '',
        phone: singleElementOfArray(resp.response).phone,
        lastName: singleElementOfArray(resp.response).lastName,
        firstName: singleElementOfArray(resp.response).firstName
      });
      setUser({
        email: singleElementOfArray(resp.response).email ? singleElementOfArray(resp.response).email : singleElementOfArray(resp.response).newEmail ? singleElementOfArray(resp.response).newEmail : '',
        phone: singleElementOfArray(resp.response).phone ? singleElementOfArray(resp.response).phone.replace('+1', '').replace('+38', '') : '',
        lastName: singleElementOfArray(resp.response).lastName,
        firstName: singleElementOfArray(resp.response).firstName
      });
      formik.setFieldTouched('email', true);
      formik.setFieldTouched('phone', true);
      formik.setFieldTouched('lastName', true);
      formik.setFieldTouched('firstName', true);
      await fetchAddresses();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountId]);
  const makesPropertyAddressAsPrimary = async () => {
    if (residencyAddresses.findIndex(i => i.isPrimary) > -1) {
      const resp = await store.residencies.setAllCustomPrimaryAddressesToSecondaryAsync.run({
        residencyId: residencyId
      });
      await fetchAddresses();
      if (resp && resp.response) toast('success', {
        body: ['Successfully saved']
      });
    }
  };
  const changePrimaryPropertyAddress = async data => {
    if (!data.isPrimary) {
      const resp = await store.residencies.updateResidencyAddressAsync.run({
        residencyId: residencyId,
        residencyAddressId: data.id,
        isPrimary: true,
        addressId: data.addressId
      });
      await fetchAddresses();
      if (resp && resp.response) toast('success', {
        body: ['Successfully saved']
      });
    }
  };
  const isDefaultAddressChecked = () => {
    const rIndex = residencyAddresses.findIndex(i => i.status === RESIDENCY_ADDRESS_STATUS.pending);
    const pIndex = residencyAddresses.findIndex(i => i.isPrimary);
    return residencyAddresses.findIndex(i => i.isPrimary) === -1 || rIndex === pIndex && residencyAddresses.filter(i => i.isPrimary).length === 1;
  };
  const changeStatus = async function (id) {
    let decline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let cStatus = 'Approved';
    if (decline) cStatus = 'Declined';
    const resp = await store.residencies.updateResidencyAddressStatusAsync.run({
      residencyId: residencyId,
      residencyAddressId: id,
      status: cStatus
    });
    await fetchAddresses();
    if (resp && resp.response) toast('success', {
      body: ['Successfully saved']
    });
  };
  const removePropertyAddresses = async id => {
    const resp = await store.residencies.deleteResidencyAddressAsync.run({
      residencyId: residencyId,
      residencyAddressId: id
    });
    await fetchAddresses();
    if (resp && resp.response) toast('success', {
      body: ['Successfully removed']
    });
  };
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: formik.handleSubmit,
    className: classes.tabWithFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.tenantFormWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('unit_modal.personal_details')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('general.first_name'),
    variant: "outlined",
    fullWidth: true,
    id: "firstName",
    name: "firstName",
    value: formik.values.firstName,
    disabled: store.company.companyFeatureStore.readOnlyResidentPersonalDetails,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
      validIsSumbitDisabled('firstName', e.target.value);
    },
    error: formik.touched.firstName && Boolean(formik.errors.firstName),
    helperText: formik.touched.firstName && translate(formik.errors.firstName, t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('general.last_name'),
    variant: "outlined",
    fullWidth: true,
    id: "lastName",
    name: "lastName",
    value: formik.values.lastName,
    disabled: store.company.companyFeatureStore.readOnlyResidentPersonalDetails,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
      validIsSumbitDisabled('lastName', e.target.value);
    },
    error: formik.touched.lastName && Boolean(formik.errors.lastName),
    helperText: formik.touched.lastName && translate(formik.errors.lastName, t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('general.email_optional'),
    variant: "outlined",
    fullWidth: true,
    id: "email",
    name: "email",
    value: formik.values.email,
    disabled: store.company.companyFeatureStore.readOnlyResidentPersonalDetails,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
      validIsSumbitDisabled('email', e.target.value);
    },
    error: formik.touched.email && Boolean(formik.errors.email),
    helperText: formik.touched.email && translate(formik.errors.email, t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(InputMask, {
    mask: "999-999-9999",
    value: formik.values.phone,
    onChange: e => {
      formik.handleChange(e);
      validIsSumbitDisabled('phone', e.target.value);
    },
    onBlur: e => {
      if (!formik.touched.phone && /\d/.test(e.target.value)) formik.setFieldTouched('phone', true);
    },
    disabled: store.company.companyFeatureStore.readOnlyResidentPersonalDetails
  }, inputProps => /*#__PURE__*/React.createElement(TextField, _extends({}, inputProps, {
    type: "tel",
    fullWidth: true,
    id: "phone",
    name: "phone",
    variant: "outlined",
    label: t('general.personal_phone_optional'),
    error: formik.touched.phone && Boolean(formik.errors.phone),
    disabled: store.company.companyFeatureStore.readOnlyResidentPersonalDetails,
    helperText: formik.touched.phone && translate(formik.errors.phone, t)
  }))))))), store.account.featureFlagsStore.getIsPmSubAccountsEnabled && linkedResidents && linkedResidents.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.unlinkDetails
  }, !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement("div", {
    className: classes.actionsBar
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: unlinkChecked,
      onChange: () => setUnlinkChecked(!unlinkChecked)
    }),
    label: 'Unlink resident'
  })), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: t('By using this option you can leave empty email or set new email to detach this account from linked residents.'),
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    state: "info",
    type: "question"
  })))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.infoDetailsUnit
  }, /*#__PURE__*/React.createElement("b", null, t('Linked residents:')), linkedResidents.map(i => /*#__PURE__*/React.createElement("div", {
    key: i.accountId
  }, /*#__PURE__*/React.createElement("b", null, i.firstName, " ", i.lastName), ' ', "(Address: ", /*#__PURE__*/React.createElement("b", null, i.accountMetadata.propertyAddress), ", Unit name:", ' ', /*#__PURE__*/React.createElement("b", null, i.accountMetadata.unitName), ")")))), /*#__PURE__*/React.createElement("div", {
    className: classes.infoDetails
  }, (!user.email || user.email.length === 0) && /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.infoDetailsUnit
  }, t('unit_modal.please_enter_email_hint')), user.email && user.email.length > 0 && /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.infoDetailsUnit
  }, /*#__PURE__*/React.createElement("b", null, t('unit_modal.please_pay_attention')), /*#__PURE__*/React.createElement("br", null), t('unit_modal.resident_will_receive_confirmation')))), /*#__PURE__*/React.createElement("div", {
    className: classes.customAddress
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Mailing addresses"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Address that is used for all paper communications (Invites & Statements)."), /*#__PURE__*/React.createElement("div", {
    className: classes.customAddressList
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.customAddressListItem)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.customAddressListItemWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.customAddressListItemCheck
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: isDefaultAddressChecked(),
      onClick: e => e.stopPropagation(),
      disabled: store.company.companyFeatureStore.readOnlyMailingAddressUpdate
    }),
    onChange: makesPropertyAddressAsPrimary,
    disabled: store.company.companyFeatureStore.readOnlyMailingAddressUpdate
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.customAddressListItemDetails
  }, /*#__PURE__*/React.createElement("span", null, "Property address"), /*#__PURE__*/React.createElement("b", null, activeResidency)), /*#__PURE__*/React.createElement("div", {
    className: classes.customAddressListItemControllers
  }, /*#__PURE__*/React.createElement(Chip, {
    label: residencyAddresses.findIndex(i => i.isPrimary) > -1 ? 'Backup' : 'Primary',
    variant: residencyAddresses.findIndex(i => i.isPrimary) > -1 ? 'inactive' : 'success'
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    size: "small",
    disabled: true,
    'custom-attribute': '264-resident-details-tab'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), t('general.edit'))))), residencyAddresses.map(i => {
    var _i$details;
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.customAddressListItem, " ").concat(i.status === RESIDENCY_ADDRESS_STATUS.pending ? 'request' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressListItemWrapper
    }, i.status !== RESIDENCY_ADDRESS_STATUS.pending && /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressListItemCheck
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: i.isPrimary,
        onClick: e => e.stopPropagation(),
        disabled: store.company.companyFeatureStore.readOnlyMailingAddressUpdate
      }),
      onChange: () => {
        changePrimaryPropertyAddress(i);
      },
      disabled: store.company.companyFeatureStore.readOnlyMailingAddressUpdate
    })), /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressListItemDetails
    }, /*#__PURE__*/React.createElement("span", null, i.status === RESIDENCY_ADDRESS_STATUS.pending ? 'Requested address' : 'Address'), /*#__PURE__*/React.createElement("b", null, "".concat(i.details.street, " ").concat(i.details.city, ", ").concat(i.details.state, " ").concat(i.details.zip).concat((_i$details = i.details) !== null && _i$details !== void 0 && _i$details.secondary ? ', ' + i.details.secondary : ''))), /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressListItemControllers
    }, /*#__PURE__*/React.createElement(Chip, {
      label: i.isPrimary ? 'Primary' : 'Backup',
      variant: i.isPrimary ? 'success' : 'inactive'
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressListItemControllersActions
    }, i.status !== RESIDENCY_ADDRESS_STATUS.pending && !store.company.companyFeatureStore.readOnlyMailingAddressUpdate && /*#__PURE__*/React.createElement(RequestToUseCustomAddress, {
      residencyId: residencyId,
      callback: fetchAddresses,
      data: i
    }), /*#__PURE__*/React.createElement(Button, {
      variant: "menuAction",
      size: "small",
      disabled: store.company.companyFeatureStore.readOnlyMailingAddressUpdate,
      onClick: () => {
        removePropertyAddresses(i.id);
      },
      'custom-attribute': '265-resident-details-tab'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "trash"
    }), t('Remove'))))), i.status === RESIDENCY_ADDRESS_STATUS.pending && /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressListItemCaption
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressListItemCaptionData
    }, user.firstName, " ", user.lastName, " has requested to ", i.isPrimary ? 'change the primary' : 'add the', ' ', "mailing address. Would you like to approve new address?"), /*#__PURE__*/React.createElement("div", {
      className: classes.customAddressListItemCaptionControllers
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "text",
      size: "small",
      disabled: store.company.companyFeatureStore.readOnlyMailingAddressUpdate,
      onClick: () => changeStatus(i.id, true),
      'custom-attribute': '267-resident-details-tab'
    }, "Decline"), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      size: "small",
      disabled: store.company.companyFeatureStore.readOnlyMailingAddressUpdate,
      onClick: () => changeStatus(i.id),
      'custom-attribute': '266-resident-details-tab'
    }, "Approve"))));
  })), !store.company.companyFeatureStore.readOnlyMailingAddressUpdate && /*#__PURE__*/React.createElement(RequestToUseCustomAddress, {
    residencyId: residencyId,
    callback: fetchAddresses
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.footer
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    disabled: !formik.isValid || !Object.keys(formik.touched).length || isSumbitDisabled,
    'custom-attribute': '268-resident-details-tab'
  }, t('buttons.submit'))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading || store.account.getUsersProfilesAsync.inProgress || store.account.updateProfileByAccountIdAsync.inProgress || store.account.updateEmailByAccountIdAsync.inProgress || store.account.updatePhoneByAccountIdAsync.inProgress
  }));
});